type AuthInputProps = {
  type: 'email' | 'password';
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  isFirst?: boolean;
  isLast?: boolean;
};

export default function AuthInput({
  type,
  value,
  onChange,
  placeholder,
  isFirst,
  isLast,
}: AuthInputProps) {
  return (
    <input
      type={type}
      required
      className={`
        appearance-none relative block w-full px-3 py-2 border border-gray-300 
        placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 
        focus:border-indigo-500 focus:z-10 sm:text-sm
        ${isFirst ? 'rounded-t-md' : ''}
        ${isLast ? 'rounded-b-md' : ''}
        ${!isFirst && !isLast ? 'rounded-none' : ''}
      `}
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  );
}